import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../stores/useAuthStore";

export default function noRequireAuth(ComposedComponent) {
  function NotAuthentication(props) {
    const navigate = useNavigate();
    const authenticated = useAuthStore((state) => state.authenticated);

    useEffect(() => {
      if (authenticated) {
        navigate("/");
      }
    }, [authenticated, navigate]);

    if (authenticated) return null;
    return <ComposedComponent {...props} />;
  }

  return NotAuthentication;
}
